import React, { useState } from 'react';
import styled from 'styled-components';
import useAddOfficers from '../Hooks/IAofficersHooks/useAddOfficers'; // Adjust path if needed

const IAOfficersFormAdd = ({ darkMode, toggleDarkMode, onSelect, ia_profile_id }) => {
  // Use your custom hook for submitting data
  const { addOfficer, loading, error } = useAddOfficers();

  // Form state to capture inputs
  const [formData, setFormData] = useState({
    lastname: '',
    firstname: '',
    middle_name: '',
    phone_number: '',
    email: '',
    address: '',
    date_of_birth_month: '',
    date_of_birth_day: '',
    date_of_birth_year: '',
    name_of_spouse: '',
    position: '',
    appointment: '',
    tin: '',
    motto: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleBack = () => {
    console.log('Closing IAOfficersFormAdd');
    if (typeof onSelect === 'function') {
      onSelect('IAOfficers', { closeForm: true });
    } else {
      console.warn('onSelect is not a function. Failed to close IAOfficersFormAdd.');
    }
  };

  const handleSave = async () => {
    // Compose date_of_birth string, e.g., YYYY-MM-DD
    const date_of_birth = `${formData.date_of_birth_year}-${formData.date_of_birth_month.padStart(2, '0')}-${formData.date_of_birth_day.padStart(2, '0')}`;

    // Prepare payload to send
    const payload = {
      ia_profile_id,
      lastname: formData.lastname,
      firstname: formData.firstname,
      middle_name: formData.middle_name,
      phone_number: formData.phone_number,
      email: formData.email,
      address: formData.address,
      date_of_birth,
      name_of_spouse: formData.name_of_spouse,
      position: formData.position,
      appointment: formData.appointment,
      tin: formData.tin,
      motto: formData.motto,
    };

    try {
      await addOfficer(payload);
      alert('Officer added successfully!');
      handleBack(); // close form or do next step
    } catch (err) {
      alert('Failed to add officer: ' + err.message);
    }
  };

  return (
    <PageContainer darkMode={darkMode}>
      <PageContent darkMode={darkMode}>
        <PageHeader>
          <PageTitle>IA Profiling Form</PageTitle>
          <CloseButton onClick={handleBack} darkMode={darkMode} title="Close">
            ×
          </CloseButton>
        </PageHeader>

        <PersonalInfo>Personal Information</PersonalInfo>

        <FormGroup>
          <Label>Full Name:</Label>
          <InputGroup>
            <Input
              name="lastname"
              placeholder="Last Name"
              darkMode={darkMode}
              value={formData.lastname}
              onChange={handleChange}
            />
            <Input
              name="firstname"
              placeholder="First Name"
              darkMode={darkMode}
              value={formData.firstname}
              onChange={handleChange}
            />
            <Input
              name="middle_name"
              placeholder="Middle Name"
              darkMode={darkMode}
              value={formData.middle_name}
              onChange={handleChange}
            />
          </InputGroup>
        </FormGroup>

        <FormGroup>
          <Label>Contact:</Label>
          <InputGroup>
            <Input
              name="phone_number"
              placeholder="Phone Number"
              darkMode={darkMode}
              value={formData.phone_number}
              onChange={handleChange}
            />
            <Input
              name="email"
              placeholder="Email"
              darkMode={darkMode}
              value={formData.email}
              onChange={handleChange}
            />
          </InputGroup>
        </FormGroup>

        <FormGroup>
          <Label>Address:</Label>
          <Input
            name="address"
            placeholder="Street, Brgy, Municipality, Province, Country"
            darkMode={darkMode}
            value={formData.address}
            onChange={handleChange}
          />
        </FormGroup>

        <FormGroup>
          <Label>Date of Birth:</Label>
          <InputGroup>
            <Input
              name="date_of_birth_month"
              placeholder="Month"
              darkMode={darkMode}
              value={formData.date_of_birth_month}
              onChange={handleChange}
            />
            <Input
              name="date_of_birth_day"
              placeholder="Day"
              darkMode={darkMode}
              value={formData.date_of_birth_day}
              onChange={handleChange}
            />
            <Input
              name="date_of_birth_year"
              placeholder="Year"
              darkMode={darkMode}
              value={formData.date_of_birth_year}
              onChange={handleChange}
            />
          </InputGroup>
        </FormGroup>

        <FormGroup>
          <Label>Name of Spouse:</Label>
          <Input
            name="name_of_spouse"
            placeholder="Full Name"
            darkMode={darkMode}
            value={formData.name_of_spouse}
            onChange={handleChange}
          />
        </FormGroup>

        <FormGroup>
          <Label>Position:</Label>
          <InputGroup>
            <Input
              name="position"
              placeholder="Position"
              darkMode={darkMode}
              value={formData.position}
              onChange={handleChange}
            />
            <Input
              name="appointment"
              placeholder="Appointment Year"
              darkMode={darkMode}
              value={formData.appointment}
              onChange={handleChange}
            />
          </InputGroup>
        </FormGroup>

        <FormGroup>
          <Label>TIN:</Label>
          <Input
            name="tin"
            placeholder="************"
            darkMode={darkMode}
            value={formData.tin}
            onChange={handleChange}
          />
        </FormGroup>

        <FormGroup>
          <Label>Motto:</Label>
          <Textarea
            name="motto"
            placeholder="A Boss will say 'Go!' A Leader will say 'Let's go!'"
            darkMode={darkMode}
            value={formData.motto}
            onChange={handleChange}
          />
        </FormGroup>

        <SaveButton onClick={handleSave} disabled={loading}>
          {loading ? 'Saving...' : 'Save'}
        </SaveButton>

        {error && <p style={{ color: 'red' }}>{error}</p>}
      </PageContent>
    </PageContainer>
  );
};

export default IAOfficersFormAdd;


const PageContainer = styled.div`
  padding: 20px 40px 20px 20px; /* Added padding-right: 40px */
  background-color: ${props => (props.darkMode ? '#1a1a1a' : '#ffffff')};
  height: 100%;
  box-sizing: border-box;
  color: ${props => (props.darkMode ? '#ffffff' : '#333333')};
  overflow: auto;
`;

const PageContent = styled.div`
  max-width: 800px;
  margin: 0;
  padding: 23px;
  background-color: ${props => (props.darkMode ? '#333333' : '#f0f0f0')};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
`;

const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #2e7d32;
  color: #ffffff;
  padding: 10px 20px;
  margin: -20px -20px 20px -20px;
  border-top-left-radius: 8px;
  border-top-right-radius: 4px;
`;

const PageTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
`;

const CloseButton = styled.button`
  background-color: ${props => (props.darkMode ? '#555555' : '#ffffff')};
  color: ${props => (props.darkMode ? '#ffffff' : '#2e7d32')};
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  padding: 0;
  transition: background-color 0.2s;
  &:hover {
    background-color: ${props => (props.darkMode ? '#777777' : '#e0e0e0')};
  }
`;

const PersonalInfo = styled.div`
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 5px;
`;

const FormGroup = styled.div`
  margin-bottom: 15px;
`;

const Label = styled.label`
  display: block;
  font-weight: normal;
  margin-bottom: 5px;
`;

const InputGroup = styled.div`
  display: grid;
  gap: 10px;
`;

const Input = styled.input`
  padding: 8px;
  border: 1px solid #333;
  border-radius: 4px;
  flex: 1;
  background-color: ${props => (props.darkMode ? '#333333' : '#ffffff')};
  color: ${props => (props.darkMode ? '#ffffff' : '#333333')};
`;

const Textarea = styled.textarea`
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
  min-height: 60px;
  background-color: ${props => (props.darkMode ? '#333333' : '#ffffff')};
  color: ${props => (props.darkMode ? '#ffffff' : '#333333')};
`; 

const SaveButton = styled.button`
  padding: 10px 20px;
  background-color: #2e7d32;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 20px;
  &:hover {
    background-color: #1b5e20;
  }
`;